export default "__VITE_ASSET__AJhMVeon__"